export default "__VITE_ASSET__BI$t$zoo__"